import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowCurvedUpIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M11.68 13.62V6.84L7.16 11.42L5.94 10.2L12.7 3.44L19.46 10.2L18.24 11.42L13.68 6.8V13.62C13.68 16.68 11.36 19 8.3 19H3.76V17.08H8.3C10.18 17.08 11.68 15.56 11.68 13.62Z" />
    </SvgIcon>
  );
});
